export default __webpack_public_path__ + "static/media/Oneceptron_About_page_v3.ad8ac82c.svg";